module.exports = __webpack_public_path__ + "static/img/menu2-img1.55d2119a.png";